// extracted by mini-css-extract-plugin
module.exports = {"banner":"_8eb74"};